module.exports = __webpack_public_path__ + "static/media/logo.69b65974.png";